import { createGlobalStyle } from 'styled-components';

import BentonSansWideBlack from 'assets/fonts/Benton-Sans-Wide-Black.otf';
import BentonSansWideBold from 'assets/fonts/Benton-Sans-Wide-Bold.otf';
import BentonSansBold from 'assets/fonts/Benton-Sans-Bold.otf';
import BentonSansMedium from 'assets/fonts/Benton-Sans-Medium.otf';
import BentonSansRegular from 'assets/fonts/Benton-Sans-Regular.otf';

const GlobalStyle = createGlobalStyle`

  @font-face {
    font-family: "BentonSansWideBlack";
    src: url(${BentonSansWideBlack});
  }
  
  @font-face {
    font-family: "BentonSansWideBold";
    src: url(${BentonSansWideBold});
  }

  @font-face {
    font-family: "BentonSansBold";
    src: url(${BentonSansBold});
  }

  @font-face {
    font-family: "BentonSansMedium";
    src: url(${BentonSansMedium});
  }
  
  @font-face {
    font-family: "BentonSansRegular";
    src: url(${BentonSansRegular});
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    outline: none;
  }

  html,
  body,
  #root {
    height: 100%;
    scroll-behavior: smooth;
  }

  body {
    text-rendering: optimizeLegibility !important;
    -webkit-font-smoothing: antialiased !important;
    background: #111111;
    font-family: "BentonSansRegular";
    font-size: 16px;
    color: white;
    font-weight: normal;

    --webkit-overflow-scrolling: touch;
    overscroll-behavior: none;

    ::-webkit-scrollbar {
      display: none;
      -ms-overflow-style: none;
      scrollbar-width: none;
    }

  }

  body.modal-open {
    overflow-y: hidden;
  }
  body.react-select-open {
    .modal-body {
      overflow-y: auto;
      .react-select__menu {
        position: sticky;
      }
    }
  }

  a {
    text-decoration: none;
  }

  button {
    font-family: "BentonSansBold";
    border: 0;
    cursor: pointer;
    background-color: transparent;
  }

  input, textarea {
    font-family: "BentonSansRegular";
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: "BentonSansWideBold";
    font-weight: unset;
  }

  ul {
    list-style: none;
  }

  .icon-spin {
    animation: iconSpin 2s infinite linear;
  }

  @keyframes iconSpin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(359deg);
    }
  }
`;

export default GlobalStyle;
